import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

export const quickSuggestions: QuickSuggestion[] = [
  {
    id: '1',
    labelKey: 'chatbot.suggestions.services',
    messageKey: 'chatbot.suggestions.servicesMessage',
  },
  {
    id: '2',
    labelKey: 'chatbot.suggestions.packaging',
    messageKey: 'chatbot.suggestions.packagingMessage',
  },
  {
    id: '3',
    labelKey: 'chatbot.suggestions.contact',
    messageKey: 'chatbot.suggestions.contactMessage',
  },
  {
    id: '4',
    labelKey: 'chatbot.suggestions.certifications',
    messageKey: 'chatbot.suggestions.certificationsMessage',
  },
]

export const contactCTAs: ContactCTA[] = [
  {
    id: 'email',
    labelKey: 'contactForm.email',
    value: 'francesca@tecnocart.net',
    icon: 'mail',
  },
  {
    id: 'phone',
    labelKey: 'contactForm.phone',
    value: '051.6815027',
    icon: 'phone',
  },
]
